<template>
  <div>
    <h1>HOMEHOME</h1>
    <p>
      차차차차익거래
    </p>
  </div>
</template>

<script>
export default {
  name: 'HomeDetail',
  props: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
